import { useState } from 'react'
import AuthService from 'services/auth'
import cutileiApi from 'services/cutileiApi'
import { logApiError } from 'services/apiError'
import AlertDialog from 'components/AlertDialog'
import MainButton from 'components/Buttons/MainButton'
import { FaFacebook, FaInstagram, FaTiktok } from 'react-icons/fa'
import { Formik } from 'formik'

import {
  Row,
  Form,
  InputIcon,
  SubTitle,
  FormField,
  Input
} from '../../styles'

export default function SocialMedias ({
  businessId,
  socialMedias,
  businessSocialMedias,
  requestConfig,
  onDataUpdated: handleDataUpdated = () => {}
}) {
  const [showOkDialog, setShowOkDialog] = useState (false)
  const hasEditPermission = AuthService.hasPermission ('business_config.personal_data', 'edit')

  const toggleOkDialog = () => setShowOkDialog (prev => !prev)

  return (
    <Formik
      initialValues={{
        social_medias: socialMedias.map (socialMedia => ({
          id: socialMedia.id,
          name: socialMedia.name,
          base_url: socialMedia.base_url,
          link: businessSocialMedias.find (businessSocialMedia => (
            businessSocialMedia.id === socialMedia.id
          ))?.link.split ('/').pop () ?? ''
        }))
      }}
      onSubmit={async (values, { setSubmitting }) => {
        try {
          setSubmitting (true)
          const social_medias = values.social_medias.filter (socialMedia => (
            socialMedia.link !== '' && socialMedia.link !== null
          ))
          
          await cutileiApi.post (
            `/businesses/${businessId}/social_medias`,
            { social_medias },
            requestConfig
          )

          handleDataUpdated ({ social_medias })
          setSubmitting (false)
          toggleOkDialog ()
        } catch (error) {
          setSubmitting (false)
          logApiError (error)
        }
      }}
    >
      {({
        dirty,
        values,
        isSubmitting,
        setFieldValue,
        handleSubmit
      }) => (
        <Form width={420} onSubmit={handleSubmit}>
          <SubTitle>Redes Sociais</SubTitle>
          {values.social_medias.map ((socialMedia, index) => (
            <FormField key={socialMedia.id} style={{width: '100%'}}>
              <Row style={{alignItems: 'center', gap: 8}}>
                <InputIcon>
                  {socialMedia.name.toLowerCase () === 'instagram' ? (
                    <FaInstagram size={18} color='#252525'/>
                  ) : socialMedia.name.toLowerCase () === 'tiktok' ? (
                    <FaTiktok size={16} color='#000000'/>
                  ) : (
                    <FaFacebook size={19} color='#0866FF'/>
                  )}
                </InputIcon>
                <Input
                  name={`social_medias[${index}].link`}
                  placeholder={socialMedia.name}
                  value={values.social_medias[index].link}
                  disabled={!hasEditPermission}
                  onChange={event => setFieldValue (event.target.name, event.target.value)}
                  style={{paddingLeft: 40, paddingRight: 25}}
                  onBlur={() => null}
                />
              </Row>
            </FormField>
          ))}
          <AlertDialog
            visible={showOkDialog}
            title='Sucesso'
            message='Alterações salvas!'
            confirmText='Ok'
            onClose={toggleOkDialog}
          />
          {hasEditPermission && dirty && (
            <MainButton
              label='Salvar alterações'
              onClick={handleSubmit}
              disabled={isSubmitting}
              loading={isSubmitting}
              width={160}
              style={{marginTop: 5}}
            />
          )}
        </Form>
      )}
    </Formik>
  )
}
